import Icon, {iconTypes} from "../../common/components/Icon.jsx";
import {getTimeLeftStr, isTimeLeftInDays} from "../../common/util/time.js";

import {Localization} from "../../common/util/localization.jsx";
import ProgressBar from "../../common/components/ProgressBar.jsx";
import PropTypes from "prop-types";
import React from "react";
import moment from "moment";

export default class DeliveringStatus extends React.PureComponent {
    constructor(props){
        super(props);

        this.state = {
            minute: -1,
            seconds: -1,
        };

        this.checkTime = this.checkTime.bind(this);
    }
    componentDidMount() {
        this.interval = setInterval(this.checkTime, 1000);
    }
    componentWillUnmount() {
        clearInterval(this.interval);
    }
    checkTime() {
        const date = new Date;
        const eventTime = moment(this.props.deadlineDate).unix();
        const currentTime = moment().unix();
        const diffTime = eventTime - currentTime;
        const duration = moment.duration(diffTime * 1000, "milliseconds");
        const minute = moment.duration(duration).minutes();
        //if more then 2min left then update every minute, otherwise every second
        if( minute>3 ){
            if( this.state.minute!=minute){
                this.setState({minute:minute});
            }
        } else {
            const seconds = date.getSeconds();
            if( this.state.seconds!=seconds){
                this.setState({
                    minute: -1,
                    seconds:seconds
                });
            }
        }
    }
    render(){
        const {
            localization,
            isDelivered,
            deadlineDate,
            progress,
            status,
            showIcon,
            fontSize
        } = this.props;
        const marginTop = `${fontSize-16}px`;
        const closingIn = getTimeLeftStr(localization, deadlineDate);
        const isDateStrInDays = isTimeLeftInDays(deadlineDate);

        const deadlineDateFormatted = deadlineDate ? moment(deadlineDate).format("MMM DD") : "--- --";
        const deadlineTimeFormatted = deadlineDate ? moment(deadlineDate).format(`[${localization.text("time","at")}] HH:mm`) : "--:--";
      

        return (
            <React.Fragment>
                <div className="closing-detail">
                    {isDelivered ?(
                        <React.Fragment>
                            {showIcon && (
                                <div className="card-icon closing-detail-icon">
                                    <Icon type={iconTypes.circleChecked} />
                                </div>
                            )}
                            <div>
                                <div className="closing-detail-text">{localization.text("dashboard","status")}</div>
                                <div className="closing-detail-delivered">{status}</div>
                            </div>
                        </React.Fragment>
                    ) : (
                        <React.Fragment>
                            {showIcon && (
                                <div className="card-icon closing-detail-icon" style={{marginTop:marginTop}}>
                                    <Icon type={iconTypes.time} />
                                </div>
                            )}
                            <div>
                                
                                { isDateStrInDays ?(
                                    <React.Fragment>
                                        <div className="closing-detail-header">{deadlineDateFormatted}</div>
                                        <div>
                                            <div className="closing-detail-info">{deadlineTimeFormatted}</div>
                                        </div>
                                    </React.Fragment>                                  
                                ) : (
                                    <React.Fragment>
                                        <div className="closing-detail-text">{localization.text("dashboard","closingIn")}</div>
                                        <div className={isDateStrInDays?"closing-detail-days":"closing-detail-time"} style={{fontSize:fontSize}}>{closingIn}</div>
                                    </React.Fragment>   
                                )}
                               
                            </div>
                        </React.Fragment>
                    )}
                </div>
                {progress>=0 && (
                    <div style={{width:"100%","paddingRight":"16px"}}>
                        <ProgressBar progress={progress}/>
                    </div>
                )}
            </React.Fragment>
        );
    }
}
DeliveringStatus.propTypes = {
    localization: Localization.propTypes.isRequired,
    isDelivered: PropTypes.bool.isRequired,
    deadlineDate: PropTypes.string,
    progress: PropTypes.number,
    status: PropTypes.string,
    fontSize: PropTypes.number,
    showIcon: PropTypes.bool,
};
DeliveringStatus.defaultProps = {
    fontSize: 26,
    showIcon: true,
};